import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row p-3"
}
const _hoisted_2 = { class: "col-md-5 d-flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_4 = {
  key: 3,
  class: "row p-3"
}
const _hoisted_5 = {
  key: 0,
  class: "col-md-12 p-3"
}
const _hoisted_6 = { class: "row p-0 mt-0" }
const _hoisted_7 = { style: {"font-weight":"bold"} }
const _hoisted_8 = { class: "row m-0 p-0" }
const _hoisted_9 = { class: "col p-0" }
const _hoisted_10 = { style: {"font-weight":"bold"} }
const _hoisted_11 = { class: "col p-0" }
const _hoisted_12 = { style: {"font-weight":"bold"} }
const _hoisted_13 = { class: "w-100 mt-3" }
const _hoisted_14 = { class: "border border-dark" }
const _hoisted_15 = {
  colspan: "2",
  class: "pt-4",
  style: {"font-weight":"bold"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "row mt-4 p-0" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Summary:-")
], -1)
const _hoisted_17 = { class: "row p-0" }
const _hoisted_18 = { class: "row p-0" }
const _hoisted_19 = {
  key: 1,
  class: "col-md-12 p-4"
}
const _hoisted_20 = { class: "error-no-record" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheTabViewLoading = _resolveComponent("TheTabViewLoading")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_ThePageError = _resolveComponent("ThePageError")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isPageLoading && !_ctx.isDashboard)
      ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
      : _createCommentVNode("", true),
    (!_ctx.isPageLoading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["page-container card col-md-8", {'col-md-12': _ctx.isDashboard}])
        }, [
          (!_ctx.isDashboard)
            ? (_openBlock(), _createBlock(_component_ThePageHeader, {
                key: 0,
                onExportPdfEvent: _ctx.exportPdf,
                renderExportReport: !_ctx.isLoading && _ctx.pageError == '' && _ctx.journalReport != null && _ctx.journalReport.contents != null && _ctx.journalReport.contents.length > 0,
                isExporting: _ctx.isExporting
              }, null, 8, ["onExportPdfEvent", "renderExportReport", "isExporting"]))
            : _createCommentVNode("", true),
          (_ctx.pageError == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_Button, {
                    type: "button",
                    class: "p-button-sm",
                    label: "Generate",
                    onClick: _ctx.generateReport,
                    disabled: _ctx.pageError != ''
                  }, null, 8, ["onClick", "disabled"]),
                  _hoisted_3,
                  (!_ctx.isDashboard)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        class: "p-button-sm p-button-secondary",
                        label: "Back",
                        onClick: _ctx.back
                      }, null, 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_TheTabViewLoading, { key: 2 }))
            : _createCommentVNode("", true),
          (_ctx.pageError == '')
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                (_ctx.journalReport != null && _ctx.journalReport.contents != null && _ctx.journalReport.contents.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.journalReport.header.groupName), 1)
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("label", _hoisted_10, "Consolidation Journal Listing (Sorted by " + _toDisplayString(Object.keys(_ctx.journalReport.contents[0].details[0]).length == 3 ? 'account code' : 'Journal ID') + ")", 1)
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("label", _hoisted_12, "Period ended " + _toDisplayString(_ctx.journalReport.header.date), 1)
                        ])
                      ]),
                      _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", _hoisted_14, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.journalReport.contents[0].details[0]), (header, headerIndex) => {
                              return (_openBlock(), _createElementBlock("th", {
                                class: "p-1",
                                key: headerIndex,
                                style: _normalizeStyle((header == 'Accts code/JR ID' || header == 'Jr ID/Acct Code' ? 'width: 15%;' : '')+ (header == 'Accounts' ? 'width: 65%;' : '') + (header == 'Descriptions' ? 'width: 75%' : '') + (headerIndex > 1 ? 'width: 10%; text-align: right;' : ''))
                              }, _toDisplayString(header), 5))
                            }), 128))
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.journalReport.contents, (content, contentIndex) => {
                          return (_openBlock(), _createElementBlock("tbody", { key: contentIndex }, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("td", _hoisted_15, _toDisplayString(content.subtitle), 1)
                            ]),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(content.details, (account, accountIndex) => {
                              return (_openBlock(), _createElementBlock("tr", { key: accountIndex }, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(account), (account_key, account_key_index) => {
                                  return (_openBlock(), _createElementBlock("td", {
                                    key: account_key_index,
                                    style: _normalizeStyle(((accountIndex == content.details.length-1 && account_key_index > 1) ? ('border-bottom: 4px double black;') : '') + ((account[Object.keys(account)[0]] == 'Total' && account_key_index > 1) ? 'border-top: 1px solid black;' : '' ) + (account_key_index > 1 ? 'text-align: right' : ''))
                                  }, _toDisplayString(account[account_key]), 5))
                                }), 128))
                              ]))
                            }), 128))
                          ]))
                        }), 128))
                      ]),
                      _hoisted_16,
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.journalReport.summary.total), 1)
                      ]),
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("label", null, "(Retrieved on " + _toDisplayString(_ctx.formatToReportDateTime(_ctx.journalReport.summary.retrievedDate)) + ")", 1)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (!_ctx.isLoading && _ctx.journalReport != null && _ctx.journalReport.contents != null && _ctx.journalReport.contents.length == 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_FontAwesomeIcon, {
                          icon: ['fas', 'image'],
                          size: "2x"
                        }),
                        _hoisted_21
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (_ctx.pageError != '')
            ? (_openBlock(), _createBlock(_component_ThePageError, {
                key: 4,
                onBackEvent: _ctx.back,
                pageError: _ctx.pageError
              }, null, 8, ["onBackEvent", "pageError"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}